import { AuthBackgroundLayout } from '../layout/AuthBackgroundLayout';
import { PrimaryButton } from '../components/ui/Button/Buttons';
import { ExclamationCircle } from '../icons/SvgIcons';
import { PATHS } from '../constants/Paths.constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/AuthService';
import { useAppDispatch } from '../hooks/redux';
import { showToast } from '../store/slices/toastSlice';

export function ExpiredLink() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;
  const token = (location.state as { token?: string } | null)?.token;

  const isResetPasswordFlow = from === 'resetPassword';
  const isInvitationFlow = from === 'invitation';
  const isExpiredVerifyEmailFlow = from === 'verifyEmail';

  const flowContent = {
    resetPassword: {
      message: 'Your password reset link is expired or invalid.',
      buttonLabel: 'Request new reset link',
      showPrimaryButton: true,
      action: () => {
        navigate(PATHS.FORGOT_PASSWORD);
      }
    },
    invitation: {
      message: (
        <>
          Your invitation link is expired or invalid.
          <br />
          Please contact person who invited you.
        </>
      ),
      buttonLabel: '',
      showPrimaryButton: false,
      action: () => {}
    },
    verifyEmail: {
      message: 'Your registration link is invalid or has expired.',
      buttonLabel: 'Resend link',
      showPrimaryButton: true,
      action: () => {
        handleResendVerifyEmail();
      }
    },
    default: {
      message: 'The link you tried to use is expired or invalid.',
      buttonLabel: '',
      showPrimaryButton: false,
      action: () => {}
    }
  };

  const handleResendVerifyEmail = async () => {
    if (!token) {
      navigate(PATHS.CHECK_YOUR_EMAIL);
      return;
    }

    try {
      const response = await authService.resendVerifyEmail(token);
      dispatch(
        showToast({
          message: response.message,
          type: 'success'
        })
      );
      navigate(PATHS.CHECK_YOUR_EMAIL);
    } catch (error: any) {
      dispatch(
        showToast({
          message:
            error.message ||
            'Failed to resend verification email. Please try again.',
          type: 'error'
        })
      );
    }
  };

  const currentFlow =
    (isResetPasswordFlow && flowContent.resetPassword) ||
    (isInvitationFlow && flowContent.invitation) ||
    (isExpiredVerifyEmailFlow && flowContent.verifyEmail) ||
    flowContent.default;

  return (
    <div className="h-screen flex items-center justify-center">
      <AuthBackgroundLayout>
        <div className="flex flex-row items-center justify-center">
          {ExclamationCircle()}
        </div>
        <p className="text-2xl text-purple-900 font-bold text-left self-stretch">
          Link expired or invalid
        </p>
        <p className="text-base font-normal text-gray-950 text-left self-stretch">
          {currentFlow.message}
        </p>
        {currentFlow.showPrimaryButton && (
          <PrimaryButton onClick={currentFlow.action} className="w-full">
            {currentFlow.buttonLabel}
          </PrimaryButton>
        )}
      </AuthBackgroundLayout>
    </div>
  );
}
